import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const catchAndMapTo = <T>(mapToValue: T) => catchError(() => of(mapToValue));
export const isNotEmpty = <T>(value: T | undefined | null): value is T => value !== undefined && value !== null;
